import React from 'react';
import ReactDOM from 'react-dom';
import 'babel-polyfill';
import queryString from 'querystring';

import App from './App';
import './index.css';

const qs = queryString.parse(location.search.substr(1));

ReactDOM.render(
  <App code={qs.code} redeem={qs.redeem != null} />,
  document.getElementById('root')
);



/** WEBPACK FOOTER **
 ** ./src/index.js
 **/